<template>
  <article class="media">
    <div class="media-content">
      <div class="content">
        <div class="columns">
          <div class="column is-2" id="col_31">
            <label v-if="article?.printDocuments" class="tag is-light" style="margin-left: 20px;">
              Full Article, Single Pages
            </label>
            <a
              v-if="article?.printDocuments"
              :href="pdf_page"
              target="_blank"
            >
              <span v-if="article?.printDocuments" v-html="imgHtml" />
            </a>
          </div>
          <div class="column is-2" id="col_32">
            <label v-if="article.storyPdfFacing!=null" class="tag is-light" style="margin-left: 20px;">
              Article Spread(s)
            </label>
              <span v-if="article.storyPdfFacing!=null && article?.printDocuments" v-html="imgHtml" @click="openPdf(article.storyPdfFacing)"
                style="cursor:pointer" />
          </div>
          <div class="column is-8">
            <h1 v-if="printData" class="title is-3 has-text-centered">{{ publicationName }}</h1>
            <p v-if="printData" class="subtitle is-6 has-text-centered">{{ formattedCoverDate }}</p>
            <h2 v-if="article" class="subtitle is-4 has-text-centered">{{ article.storyName }}</h2>
            <p v-if="dekSubtitle" class="subtitle is-6">{{ dekSubtitle }}</p>
            <IssueArticleByline
              v-if="useUdfByline"
              :authors="udfAuthors"
            />
            <IssueArticleByline
              v-else-if="hasXmlDocument"
              :authors="[]"
              :xml-byline="xmlByline"
            />
            <p style="margin: 0em;">
              <strong>Page: </strong>{{ article.article_coverPage }}{{ pageNumberList }}
              <strong class="issue-article-word-count" style="padding-left: 17em;">{{ wordCountLabel }}</strong>
            </p>
            <p v-if="article.section"><strong>Section: </strong> {{ article.section }} </p>
          </div>
        </div>
      </div><hr>
    </div>
  </article>
</template>

<script>
import IssueArticleByline from '@/components/layout/issue/article/IssueArticleByline.vue'
import { formatCoverDate } from '@/utils/formatCoverDate'

export default {
  name: 'IssueArticleHeader',
  components: {
    IssueArticleByline
  },
  props: {
    article: {
      type: Object,
      required: true
    },
    publicationName: {
      type: String,
      required: true
    },
    coverDisplayDate: {
      type: String,
      required: true
    },
    xml_summary: {
      type: String,
      default: ''
    },
    xmlByline: {
      type: String,
      default: ''
    },
    wordCount: {
      type: Number,
      default: null
    }
  },
  computed: {
    printData () {
      return this.article?.printDocuments?.[0] ?? null
    },
    dekSubtitle () {
      const d = this.printData
      if (!d) return ''
      if (d.documentDek) return d.documentDek
      if (d.udf && d.udf.summary) return d.udf.summary
      if (d.xml && this.xml_summary) return this.xml_summary
      return ''
    },
    udfAuthors () {
      return this.printData?.documentAuthors ?? []
    },
    useUdfByline () {
      return !!(this.printData && this.printData.udf && this.udfAuthors.length)
    },
    hasXmlDocument () {
      return !!(this.printData && this.printData.xml)
    },
    pageNumberList () {
      const nums = this.printData?.pageNumbers ?? []
      return (Array.isArray(nums) ? nums : []).filter((x) => x != null).join(',')
    },
    thumb () {
      return (
        this.article?.printDocuments?.[0]?.thumbnail?.mediaSignedUrls ??
        null
      )
    },
    pdf_page () {
      return (
        this.article?.printDocuments?.[0]?.articlePdf?.mediaSignedUrls?.awsS3Download ??
        null
      )
    },
    imgHtml () {
      if (!this.thumb?.awsS3Download) return ''
      // const sizeClass = this.article.article_pdf_spread ? 'is-96x96' : 'is-128x128'
      const sizeClass = 'is-128x128' //'is-96x96'
      return (
        '<figure class="image ' + sizeClass + '" style="margin-bottom: 112px;position: unset !important;">' +
        '<img alt="Thumbnail" src="' + this.thumb.awsS3Download + '">' +
        '</figure>'
      )
    },
    wordCountLabel () {
      if (this.wordCount == null || Number.isNaN(this.wordCount)) return ''
      return 'Words: ' + this.wordCount
    },
    formattedCoverDate () {
      return formatCoverDate(this.coverDisplayDate)
    }
  },
  methods: {
    async openPdf (assetId) {
      if (!assetId?.[0]) return
      try {
        const response = await this.$http.post(
          this.imageTokenUrl,
          {
            id: assetId[0],
            origurl: true
          },
          {
            headers: {
              Authorization: 'Bearer '+this.imageTokenApiBearerToken
            }
          }
        )

        const { originalUrl } = response.data
        if (originalUrl) {
          window.open(originalUrl, '_blank')
        }
      } catch (err) {
        console.error(err)
      }
    }
  }
}
</script>

<style scoped>
  #col_3{
    height: 200px;
  }
</style>
